import React, {useEffect, useState} from "react";
import NavigationLine from "../../../assets/images/classes/line.svg";
import ActiveStudentRemoveLicenseBtn from "../../../assets/images/classes/activeStudentLicenseRemoveBtn.png";
import FinStudentRemoveLicenseBtn from "../../../assets/images/classes/finStudentLicenseRemoveBtn.png";
import ActiveStudentLicenseBtn from "../../../assets/images/classes/activeLicenseBtn.png"
import ButtonImg from "../../classStudentManagement/components/ButtonImg";
import Modal from "../../../components/Modal";
import Button from "../../classStudentManagement/components/Button";
import {
    getStudents,
    removeLicenseClassStudent,
    removeLicenseStudent,
    setActiveLicenseStudents
} from "../../../network/Endpoint";
import {messageToast} from "../../../components/Toast";
import {cloneDeep} from "lodash";
import SlashIcon from "../../../assets/images/classes/slashIcon.png";
import LicenseSelectClassMenu from "./LicenseSelectClassMenu";
import {schoolNameState, teacherNameState} from "../../../recoil/teacher/teacherIdState";
import {useRecoilRefresher_UNSTABLE, useRecoilState, useRecoilValue} from "recoil";
import closeBtn from "../../../assets/images/close_btn.png";
import ActiveLicenseModal from "./ActiveLicenseModal";
import InfoIco from "../../../assets/images/info.png";
import {fetchClassesSelector} from "../../../recoil/classes/classesState";

const ActiveLicensePage = ({activeLicenses, setActiveLicenses, classes, selectedClass, setSelectedClass, isEditable, setIsEditable, mainClass}) =>{
    const [isRemoveLicenseModalOpen, setIsRemoveLicenseModalOpen] = useState(false);
    const [isRemoveClassLicenseModalOpen, setIsRemoveClassLicenseModalOpen] = useState(false);
    const [isActiveLicenseModalOpen, setIsActiveLicenseModalOpen] = useState(false);
    const [removeLicenseIndex, setRemoveLicenseIndex] = useState(null);
    const [students, setStudents] = useState(null);
    const [selectedIndexList, setSelectedIndexList] = useState([]);
    const [selectedStudentList, setSelectedStudentList] = useState([]);
    const teacherName = useRecoilValue(teacherNameState);
    const schoolName = useRecoilValue(schoolNameState);
    const [selectedLicense, setSelectedLicense] = useState(null);
    const [removableStudents, setRemovableStudents] = useState([]);

    const refreshClasses = useRecoilRefresher_UNSTABLE(fetchClassesSelector);


    const fetchGetStudents = async (classId) => {
        try {
            const body = {
                classId: classId
            };
            const res = await getStudents(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                const students = res.data.data.students;
                setStudents(cloneDeep(students));
            } else {
                alert(`[${statusCode}] ERROR: 오류가 발생했어요. 아크수학으로 문의해 주세요.`);
            }
        } catch (error) {
            alert('오류가 발생했어요. 아크수학으로 문의해 주세요.');
        }
    };

    // 적용하기 버튼 눌러서 적용 모달 띄우기
    const activeLicenseModalOpen = (item) =>{
        setIsEditable(false);
        setSelectedLicense(item);
        setSelectedStudentList([]);
        setSelectedIndexList([]);
        setIsActiveLicenseModalOpen(true)
    }

    // 적용하기 모달에서 저장하기 누르기
    const handleActiveLicenseStudents = () => {
        if(selectedStudentList.length === 0){
            messageToast({message:"학생을 선택해 주세요."});
            return;
        }
        if((selectedLicense.activeCount + selectedStudentList.length) > selectedLicense.totalCount ){
            messageToast({message:"이용권이 부족합니다."});
            return;
        }
        fetchActiveLicenseStudents();
        setSelectedStudentList([]);
        setSelectedIndexList([]);
    };

    // 학생들에게 라이센스 적용하기 통신
    const fetchActiveLicenseStudents = async() => {
        try{
            const studentsIdList = {
                studentsIdList: selectedStudentList
            }
            const body = {
                licenseId: selectedLicense.licenseId,
                request: studentsIdList
            }
            const res = await setActiveLicenseStudents(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                const licenses = cloneDeep(res.data.data.licenseList)
                const matchedLicense = licenses.find(license => license.licenseId === selectedLicense.licenseId);

                setActiveLicenses(licenses);
                setSelectedLicense(matchedLicense);
                fetchGetStudents(selectedClass.classId);
                refreshClasses();
                messageToast({message:"이용권을 적용하였습니다.",description:selectedClass.name});
                setStudents((prevStudents) =>
                    prevStudents.map(student => {
                        if (selectedStudentList.includes(student.studentId)) {

                            // 남은 일수 계산
                            const today = new Date();
                            const endDate = new Date(selectedLicense.endDate);
                            const diffTime = today - endDate; // 밀리초 단위 차이
                            const leftDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // 일(day) 단위 변환

                            return {
                                ...student,
                                teacherLicenseId: selectedLicense.licenseId,
                                leftLicenseDate: leftDays
                            };
                        }
                        return student;
                    })
                );
            } else {
                alert(`[${statusCode}] ERROR: 오류가 발생했어요. 아크수학으로 문의해 주세요.`);
            }
        }catch (error) {
            alert('오류가 발생했어요. 아크수학으로 문의해 주세요.');
        }
    }

    const handleRemoveLicenseStudent = () => {
        fetchRemoveLicenseStudent(students[removeLicenseIndex]);
        setRemoveLicenseIndex(null);
        setIsRemoveLicenseModalOpen(false);
    };

    // 학생1명 라이센스 해제하기
    const fetchRemoveLicenseStudent = async (student) => {
        try {
            const body = {
                studentId: student.studentId
            };
            const res = await removeLicenseStudent(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                const licenses = cloneDeep(res.data.data.licenseList)
                setActiveLicenses(licenses);

                const updatedStudents = students.map((student, index) =>
                    index === removeLicenseIndex
                        ? {...student, leftLicenseDate: -1, teacherLicenseId: null} // 해당 학생만 젼경
                        : student // 나머지 학생들은 유지
                );
                setStudents(updatedStudents);
                fetchGetStudents(selectedClass.classId);
                refreshClasses();

                messageToast({message:"학생의 이용권이 해제 되었습니다.",description:student.number+"번 / "+student.name});
            } else {
                alert(`[${statusCode}] ERROR: 오류가 발생했어요. 아크수학으로 문의해 주세요.`);
            }
        } catch (error) {
            alert('오류가 발생했어요. 아크수학으로 문의해 주세요.');
        }
    };


    const handleRemoveClassLicenseStudent = () => {

        fetchRemoveClassLicenseStudent();
        setRemoveLicenseIndex(null);
        setIsRemoveClassLicenseModalOpen(false)
    };

    // 클래스 학생 전체 라이센스 해제하기
    const fetchRemoveClassLicenseStudent = async () => {
        try {
            const body = {
                classId: selectedClass.classId
            };
            const res = await removeLicenseClassStudent(body);

            const statusCode = res.data.status.code;
            if (statusCode === 'Success') {
                const licenses = cloneDeep(res.data.data.licenseList);
                setActiveLicenses(licenses);
                // 모든 학생의 leftLicenseDate를 0, teacherLicenseId를 null로 업데이트
                setStudents(prevStudents =>
                    prevStudents.map(student => ({
                        ...student,
                        leftLicenseDate: 0,
                        teacherLicenseId: null
                    }))
                );
                fetchGetStudents(selectedClass.classId);
                refreshClasses();

                messageToast({message:"이용권이 해제 되었습니다."});
            } else {
                alert(`[${statusCode}] ERROR: 오류가 발생했어요. 아크수학으로 문의해 주세요.`);
            }
        } catch (error) {
            alert('오류가 발생했어요. 아크수학으로 문의해 주세요.');
        }
    };


    const onRemoveStudentLicense = (index) => {
        setRemoveLicenseIndex(index);
        setIsRemoveLicenseModalOpen(true);
    }

    const onRemoveClassLicense = () => {
        setIsRemoveClassLicenseModalOpen(true);
    }

    useEffect( () => {
        if(selectedClass){
            fetchGetStudents(selectedClass.classId)
        }else if(mainClass){
            setSelectedClass(mainClass);
        }
    }, [selectedClass, mainClass])

    useEffect(() => {
        if (students && students.length > 0) {
            const filteredStudents = students.filter(student => student.leftLicenseDate >= 0);
            setRemovableStudents(filteredStudents);
        } else {
            setRemovableStudents([]); // 학생이 없을 경우 빈 배열로 초기화
        }
    }, [students]);

    return (
        <>
        <div className="my-8 text-xl font-medium text-center text-zinc-600 max-md:max-w-full">
            학급/학생에게 등록한 이용권을 적용할 수 있습니다.
        </div>

        <div
            className="flex justify-start text-left ml-[10px] mt-[37px] text-[#50555F] text-[24px] font-[700] w-[990px] mb-5">
            이용권 적용
        </div>
        <div className="flex flex-col items-start mb-4">
            <div
                className="flex justify-between items-center w-[990px] max-w-[1044px] rounded-[10px] bg-[#F3F7FF] border-[1px] border-[#DCE8FF]">
                <div
                    className="flex w-[260px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                    이용권 상품명
                </div>
                <div
                    className="flex w-[100px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                    기간
                </div>
                <div
                    className="flex w-[260px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                    이용 기간
                </div>
                <div
                    className="flex w-[260px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                    적용 개수 / 총 개수
                </div>
                <div
                    className="flex w-[164px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                    적용
                </div>
            </div>
        </div>
        <div className="flex flex-col items-start gap-4">
            {activeLicenses && activeLicenses.length > 0 ? activeLicenses.map((item, index) => (

                <div
                    key={index}
                    className="flex justify-between items-center w-[990px] max-w-[1044px] rounded-[10px] bg-[#FFFFFF] border-[1px] border-[#DADADA]">
                    <div
                        className="flex w-[260px] h-[56px] p-[8px] justify-center items-center text-[#5E6169] text-[14px] text-center font-[500] border-r-[1px] border-[#DADADA]">
                        {item.voucherName}
                    </div>
                    <div
                        className="flex w-[100px] h-[56px] p-[8px] justify-center items-center text-[#5E6169] text-[14px] text-center font-[500]  border-r-[1px] border-[#DADADA]">
                        {item.duration}개월
                    </div>
                    <div
                        className="flex w-[260px] h-[56px] p-[8px] justify-center items-center text-[#5E6169] text-[14px] text-center font-[500]  border-r-[1px] border-[#DADADA]">
                        {item.licensePeriod}
                    </div>
                    <div
                        className="flex w-[260px] h-[56px] p-[8px] justify-center items-center text-[#355BDF] text-[20px] text-center font-[900] border-r-[1px] border-[#DADADA]">
                        {item.activeCount}<span className="text-[14px]">명</span>/<span
                        className="text-[20px] text-[#5E6169]">{item.totalCount}</span><span
                        className="text-[14px] text-[#5E6169]">명</span>
                    </div>
                    <div
                        className="flex w-[164px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                        <ButtonImg
                            image={ActiveStudentLicenseBtn}
                            onClick={() => activeLicenseModalOpen(item)}
                        />
                    </div>
                </div>

            )) : (
                <div>
                    적용가능한 이용권이 없습니다.
                </div>
            )}
        </div>
        <div className="w-full flex justify-center items-center ">
            <img
                loading="lazy"
                src={NavigationLine}
                alt=""
                className="mt-10  w-[1044px] mb-9"
            />
        </div>

        <div
            className="flex justify-between text-left ml-[10px] mt-[37px] text-[#50555F] text-[24px] font-[700] w-[980px] mb-5">
            <div className="flex h-[45px]">클래스별 적용 현황</div>
            {removableStudents && removableStudents.length > 0 ? (
                <ButtonImg
                    image={isEditable ? FinStudentRemoveLicenseBtn : ActiveStudentRemoveLicenseBtn}
                    className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                    onClick={() => setIsEditable(!isEditable)}
                />
            ) : <></>}
        </div>
            <div
                className="flex justify-between items-center w-[990px] mb-[20px] px-[80px] py-[27px] rounded-[20px] bg-[#FFFFFF] border-[1px] border-[#DADADA] gap-[56px] relative">
                <div
                    className={`absolute left-[-55px] top-[30px] flex flex-col gap-[16px] ${
                        isEditable ? removableStudents.length > 0 ? "" : "hidden" : "hidden"
                    }`}
                >
                    <button
                        onClick={onRemoveClassLicense}
                        className={`flex items-center gap-2 px-1 py-1 text-white bg-red-400 hover:bg-red-600 rounded-[10px]`}
                    >
                        <div className="text-white text-base font-semibold text-center w-[36px] inline leading-[18px]">전체해제</div>
                    </button>
                </div>
                <div className="flex text-[#50555F] text-[20px] font-medium my-3 gap-4 max-w-[270px]">
                    <div>
                        {teacherName && teacherName}
                    </div>
                    <div>
                        |
                    </div>
                    <div>
                        {schoolName && schoolName}
                    </div>
                </div>
                <div
                    className="w-[498px] h-[44px] rounded-full relative"
                >
                    <LicenseSelectClassMenu
                        classList={classes}
                        selectedClass={selectedClass}
                        setSelectedClass={setSelectedClass}
                        setIsEditable={setIsEditable}
                        type="removeLicense"
                    />
                </div>
            </div>

            <div className="flex flex-col items-start mb-4 w-[1044px]">
                <div
                    className="flex justify-between items-center w-[990px] max-w-[990px] ml-[27px] rounded-[10px] bg-[#F3F7FF] border-[1px] border-[#DCE8FF]">
                    <div
                        className="flex w-[100px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                        번호
                    </div>
                    <div
                        className="flex w-[300px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                    이름
                </div>
                <div
                    className="flex w-[644px] h-[56px] p-[8px] justify-center items-center text-[#9BA5C2] text-[18px] text-center font-[700]">
                    이용 기간
                </div>
            </div>
        </div>
        <div className="flex flex-col items-start gap-4 mb-48 w-[1044px]">
            {students && students.length > 0 ? students.map((item, index) => {
                // activeLicenses에서 item.teacherLicenseId와 일치하는 항목 찾기
                const matchedLicense = activeLicenses?.find(license => license.licenseId === item.teacherLicenseId);

                return (
                    <div
                        key={index}
                        className="flex w-[1044px] max-w-[1044px] relative"
                    >
                        <div
                            className={`absolute left-[-25px] top-[9px] flex flex-col gap-[16px] ${
                                isEditable ? matchedLicense ? "" : "hidden" : "hidden"
                            }`}
                        >
                            <button
                                onClick={() => onRemoveStudentLicense(index)}
                            >
                                <img src={SlashIcon} alt="Slash Icon"/>
                            </button>
                        </div>
                        <div
                            className="flex justify-between items-center w-[990px] max-w-[990px] ml-[27px] rounded-[10px] bg-[#FFFFFF] border-[1px] border-[#DADADA]"
                        >
                            <div
                                className="flex w-[100px] h-[56px] p-[8px] justify-center items-center text-[#5E6169] text-[14px] text-center font-[500] border-r-[1px] border-[#DADADA]"
                            >
                                {item.number}
                            </div>
                            <div
                                className="flex w-[300px] h-[56px] p-[8px] justify-center items-center text-[#5E6169] text-[14px] text-center font-[500]  border-r-[1px] border-[#DADADA]"
                            >
                                {item.name}
                            </div>
                            <div
                                className="flex w-[644px] h-[56px] p-[8px] justify-center items-center text-[#5E6169] text-[14px] text-center font-[500] border-r-[1px] border-[#DADADA]"
                            >
                                {matchedLicense ? matchedLicense.licensePeriod : "이용권이 적용되어 있지 않습니다."}
                                {(item.leftLicenseDate >=0   && item.leftLicenseDate < 10)?
                                    <img
                                        src={InfoIco}
                                        alt="info icon"
                                        className="ml-[10px]"
                                    ></img>
                                    : <></> }
                            </div>
                        </div>
                    </div>
                );
            }) : (
                <div
                    className="flex justify-center items-center w-[990px] max-w-[990px] h-[56px] ml-[27px] rounded-[10px] bg-[#FFFFFF] border-[1px] border-[#DADADA] text-center"
                >
                    학생이 없습니다.
                </div>
            )}
        </div>

    {/* 이용권 적용하기 모달 */}
    <ActiveLicenseModal
        classes={classes}
        selectedClass={selectedClass}
        setSelectedClass={setSelectedClass}
        selectedLicense={selectedLicense}
        students={students}
        teacherName={teacherName}
        schoolName={schoolName}
        selectedIndexList={selectedIndexList}
        setSelectedIndexList={setSelectedIndexList}
        selectedStudentList={selectedStudentList}
        setSelectedStudentList={setSelectedStudentList}
        isActiveLicenseModalOpen={isActiveLicenseModalOpen}
        setIsActiveLicenseModalOpen={setIsActiveLicenseModalOpen}
        handleActiveLicenseStudents={handleActiveLicenseStudents}
    />
    {/* 이용권 삭제 확인 모달 */}
    <Modal
        isOpen={isRemoveLicenseModalOpen}
        onClose={() => setIsRemoveLicenseModalOpen(false)}
    >
        <h2 className="text-[28px] font-[700] mb-3">이용권 해제</h2>
        <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
        <p className="my-8 text-2xl font-normal"><span
            className="text-[#355bdf]">[{students && students[removeLicenseIndex] && students[removeLicenseIndex].number}번/{students && students[removeLicenseIndex] && students[removeLicenseIndex].name}] </span><br/>학생의
            이용권을 해제 하시겠습니까?</p>
        <div className="flex justify-center gap-4">
            <Button
                label="취소"
                className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                        onClick={() => setIsRemoveLicenseModalOpen(false)}
                    />
                    <Button label="해제하기" onClick={handleRemoveLicenseStudent}/>
                </div>
    </Modal>
    {/* 이용권 전체 삭제 확인 모달 */}
    <Modal
        isOpen={isRemoveClassLicenseModalOpen}
        onClose={() => setIsRemoveClassLicenseModalOpen(false)}
    >
        <h2 className="text-[28px] font-[700] mb-3">클래스 이용권 해제</h2>
        <div className="border-[1px] bg-[#D3D3D3] w-[416px] mx-[15px]"></div>
        <p className="my-8 text-2xl font-normal"><span
            className="text-[#FC5955]">해당 클래스 전체의</span><br/>
            이용권을 해제 하시겠습니까?</p>
        <div className="flex justify-center gap-4">
            <Button
                label="취소"
                className="bg-[#BFBFBF] text-black hover:bg-gray-400"
                onClick={() => setIsRemoveClassLicenseModalOpen(false)}
            />
            <Button label="해제하기" onClick={handleRemoveClassLicenseStudent}/>
        </div>
    </Modal>

        </>
    )
}

export default ActiveLicensePage;